export default class Packet {
  constructor({ id, duration, speed, price, ends = null, oldPrice = null }) {
    this.id = id;
    this.duration = duration;
    this.speed = speed;
    this._price = price;
    this.ends = ends;
    this.oldPrice = oldPrice != null ? oldPrice / 100 : null;
    Object.freeze(this);
  }

  get price() {
    return this._price / 100;
  }
}
